// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a2181ffb","845":"2d834bfa"}[chunkId] + ".chunk.js";
};